export const QuoteTitle = ({
	title,
	className = "",
}: {
	title: string;
	className?: string;
}) => {
	return (
		<h2
			className={`text-accent-foreground text-lg text-center mb-2 ${className}`}
			data-testid="quote-title"
		>
			{title}
		</h2>
	);
};
